.root {
  display: inline;

  span {
    overflow-wrap: anywhere;
  }

  span:hover {
    cursor: pointer;
    background-color: var(--karaoke-sentence-hover);
  }

  span:not([data-time-start]) {
    &:hover {
      cursor: text;
      background-color: transparent;
    }
  }
}

.highlight {
  font-weight: var(--font-weight-bold);
}

.peep {
  max-height: 8.2rem;
  overflow: auto;
}

.sentence {
  position: relative;
}

.distance {
  display: flex;
  align-items: center;
  margin: 1rem 0;
  color: var(--blue-500);
  white-space: nowrap;
  pointer-events: none;

  div {
    padding: 0 0.5rem;
  }

  &::before,
  &::after {
    display: inline-block;
    flex-shrink: 1;
    width: 100%;
    height: 1px;
    content: "";
    background-color: currentColor;
  }
}

.brTop {
  display: block;
  margin-top: 1rem;
}

.brBottom {
  display: block;
  margin-bottom: 1rem;
}

.removed {
  text-decoration: line-through;
  opacity: 0.6;
}
